<template>
    <div class="row VyInformation">
        TODO: InfoView
        <!--Asta:InfoView TODO blå ruta m info-->
    </div>
</template>
<script lang="ts" setup>
</script>